
import { IDoctorListItem, IDoctor, PossibleTypes, IFacilityDept, DoctorListEvents } from "@/models/doctor";
import { IFacility } from "@/models/facility";
import { defineComponent, onMounted, PropType, reactive } from "vue";
import DoctorList from "@/components/common/Doctors/DoctorList.vue";
import _ from "lodash";
import { getDoctorList } from "@/services/doctor";

export default defineComponent({
  name: "doctors",
  emits: [DoctorListEvents.SelectedDoctor, DoctorListEvents.UpdatePDoctor],
  props: {
    required: Boolean, //필수입력값 표시여부
    isEditable: Boolean,
    notSelectable: Boolean, // 의사 선택(request), 선택불가(마이페이지)
    possibleTypes: {
      type: Number as PropType<PossibleTypes>,
      required: true,
    },
    doctorKey: { // 선택할 의사
      type: Number,
      required: false,
    },
    pDoctors: { // 의사 리스트
      type: Object as PropType<IDoctor>,
    },
    isHeight: {
      type: Boolean,
      default: true,
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
    hcode: String,
    dcode: String,
  },
  setup(props, { emit }) {
    const doctors: IDoctor | null = reactive({
      selectedFacility: {} as IFacility,
      selectedDept: {} as IFacilityDept,
      doctorList: [] as Array<IDoctorListItem>,
      doctorListSplit: [] as Array<Array<IDoctorListItem>>,
      selectedDoctor: [] as Array<IDoctorListItem>,
      selectedPage: 0,
      displayDoctorRow: 0,
    });

   
    const state = reactive({
      doctorListLoading: false,
      required: props.required,
      isEditable: props.isEditable,
      possibleTypes: props.possibleTypes,
      doctorKey: props.doctorKey,
      notSelectable: props.notSelectable,
      isHeight: props.isHeight,
      isFavorite: props.isFavorite,
    });

    // 의사가 선택된 이벤트
    const onSelectedDoctor = (doctor: IDoctor) => {
      console.log(doctor, 'Doctors.onSelectedDoctor');
      if (state.notSelectable) return;
      if(doctor) {
        doctors.selectedDoctor = doctor.selectedDoctor;
        doctors.selectedPage = doctor.selectedPage;
        doctors.selectedDept = doctor.selectedDept;
        doctors.selectedFacility = doctor.selectedFacility;
      } else {
        doctors.selectedDoctor = [];
        doctors.selectedPage = 0;
        doctors.selectedFacility = null;
        doctors.selectedDept = { FacilityKey: 0, FacilityName: '', DeptKey: 0, DeptName:'', DeptId:'' };
      }
      emit(DoctorListEvents.SelectedDoctor, doctors);
    };

    const setDoctorList = async () => {
      console.log(props.pDoctors, 'Doctors.setDoctorList.pDoctors');

      if (props.pDoctors) {
        doctors.doctorList = props.pDoctors.doctorList;
      } else {
        doctors.doctorList = (
          (await getDoctorList(state.possibleTypes)) as IDoctor
        ).doctorList;
      }
    };

    const onSetData = async () => {
      console.log(props.pDoctors, 'Doctors.onSetData.pDoctors');

      if (props.pDoctors) {
        doctors.doctorList = props.pDoctors.doctorList;
        doctors.doctorListSplit = props.pDoctors.doctorListSplit;
        doctors.selectedFacility = props.pDoctors.selectedFacility;
        doctors.selectedDoctor = props.pDoctors.selectedDoctor;
        doctors.selectedPage = props.pDoctors.selectedPage;
        doctors.displayDoctorRow = props.pDoctors.displayDoctorRow;
      } else {
        await setDoctorList();

        if (state.doctorKey) {
          await Promise.all(
            (doctors.selectedDoctor = doctors.doctorList.filter((x, index) => {
              if (x.DoctorKey === state.doctorKey) {
                doctors.selectedPage = Number.parseInt(
                  (index / doctors.displayDoctorRow.valueOf()).toString()
                );
                return x;
              }
            }))
          );
        }

        if (!doctors.displayDoctorRow) {
          doctors.doctorListSplit = [doctors.doctorList];
          doctors.selectedPage = 0;
        } else {
          if (state.isEditable)
            doctors.doctorListSplit = _.chunk(
              doctors.doctorList,
              doctors.displayDoctorRow.valueOf()
            );
          else {
            doctors.doctorList = doctors.selectedDoctor;
            doctors.doctorListSplit = [doctors.selectedDoctor];
            doctors.selectedPage = 0;
          }
        }

        // edit에서 의사 선택 화면 갈 때 마다 새로 load 방지
        emit(DoctorListEvents.UpdatePDoctor, doctors);
      }

      state.doctorListLoading = true;
    };

    onMounted(async () => {
      await onSetData();
    });

    
    return { doctors, state, onSelectedDoctor, onSetData  };
  },
  components: {
    DoctorList,
  },
});
